import { DeleteFilled, EditOutlined, EyeFilled } from "@ant-design/icons";
import {
  Button,
  Col,
  DatePicker,
  Pagination,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
  Typography,
  theme,
} from "antd";
import Paragraph from "antd/lib/typography/Paragraph";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import TextWithBR from "../../../../components/common/TextWithBR";
import NotFound from "../../../../components/common/notFound";
import useTouchpoint from "../../../../lib/hooks/useTouchpoint";
import { routes } from "../../../../routes";

const dateFormat = "DD/MM/YYYY";
const { RangePicker } = DatePicker;
const { Text } = Typography;
const { Option } = Select;
const { useToken } = theme;

const TableList = ({
  dataSource,
  permissionView,
  isAdmin,
  setOpenModal,
  onDelete,
  setFetchData,
  onSorter,
  onPageChange,
  roleUser,
}) => {
  const navigate = useNavigate();
  const { token } = useToken();
  const [loading, setLoading] = useState(false);
  const {
    questionValues,
    setQuestionValues,
    headerValues,
    setHeaderValues,
    searchValues,
    setSearchValues,
    pageValues,
    setPageValues,
    search,
    setSearch,
  } = useTouchpoint();

  const columns = [
    {
      title: "ชื่อหน่วยงาน/ชื่อนิคม",
      dataIndex: "institutionId",
      key: "institutionName",
      sorter: (a, b) => a.institutionId - b.institutionId,
      width: 350,
      render: (name, record) => (
        <>
          <TextWithBR
            line1={record.institutionName}
            line2={record.estateName}
            color={"#82858E"}
          />
        </>
      ),
    },
    {
      title: "ช่องทาง Touch Point",
      dataIndex: "channel",
      key: "header",
      sorter: (a, b) => a.channel - b.channel,
      width: 150,
      render: (header, record) => (
        <>
          <Paragraph style={{ width: 150 }}>{record.header}</Paragraph>
        </>
      ),
    },
    {
      title: "ปีงบประมาณ",
      dataIndex: "yearOfBudget",
      key: "yearOfBudget",
      sorter: (a, b) => a.yearOfBudget - b.yearOfBudget,
      width: 120,
      render: (yearOfBudget, record) => (
        <>
          <Text>{yearOfBudget ? yearOfBudget : "-"}</Text>
        </>
      ),
    },
    {
      title: "รายไตรมาส",
      dataIndex: "quarterOfBudget",
      key: "quarterOfBudget",
      sorter: (a, b) => a.quarterOfBudget - b.quarterOfBudget,
      width: 120,
      render: (quarterOfBudget, record) => (
        <>
          <Text>{quarterOfBudget ? quarterOfBudget : "-"}</Text>
        </>
      ),
    },
    {
      title: "กลุ่มลูกค้าตามสัญชาติ",
      dataIndex: "groupsByNationality",
      key: "groupsByNationality",
      sorter: (a, b) => a.groupsByNationality - b.groupsByNationality,
      width: 500,
      render: (groupsByNationality, record) => (
        <>
          <Text>{groupsByNationality ? groupsByNationality : "-"}</Text>
        </>
      ),
    },
    {
      title: "กลุ่มลูกค้าตามอายุ",
      dataIndex: "groupsByAge",
      key: "groupsByAge",
      sorter: (a, b) => a.groupsByAge - b.groupsByAge,
      width: 500,
      render: (groupsByAge, record) => (
        <>
          <Text>{groupsByAge ? groupsByAge : "-"}</Text>
        </>
      ),
    },
    {
      title: "ตามต้องการแต่ละด้าน",
      dataIndex: "expectation",
      key: "expectation",
      sorter: (a, b) => a.expectation - b.expectation,
      width: 300,
      render: (expectation) =>
        expectation ? (
          <Tooltip placement="bottomRight" title={expectation}>
            <Paragraph
              style={{ width: 250 }}
              ellipsis={{ rows: 2, expandable: true, symbol: "more" }}
            >
              {expectation}
            </Paragraph>
          </Tooltip>
        ) : (
          `-`
        ),
    },
    {
      title: "ตามความคาดหวังแต่ละด้าน",
      dataIndex: "requirement",
      key: "requirement",
      sorter: (a, b) => a.requirement - b.requirement,
      width: 300,
      render: (requirement) =>
        requirement ? (
          <Tooltip placement="bottomRight" title={requirement}>
            <Paragraph
              style={{ width: 250 }}
              ellipsis={{ rows: 2, expandable: true, symbol: "more" }}
            >
              {requirement}
            </Paragraph>
          </Tooltip>
        ) : (
          `-`
        ),
    },

    {
      title: "การจัดการ",
      dataIndex: "t8",
      key: "t8",
      width: 100,
      render: (t8, record) => (
        <Space>
          {!roleUser[0]?.isEdit &&
            !roleUser[0].isDelete &&
            roleUser[0]?.isView && (
              <Button
                className="btn-view"
                shape="circle"
                icon={<EyeFilled style={{ color: "#2E90FA" }} />}
                onClick={() =>
                  navigate(routes.view_customer_touchpoint, {
                    state: {
                      id: record,
                      action_type: "VIEW",
                    },
                  })
                }
              />
            )}

          {roleUser[0]?.isEdit && (
            <Button
              className="btn-edit"
              shape="circle"
              icon={<EditOutlined style={{ color: "#F79009" }} />}
              onClick={() =>
                navigate(routes.add_customer_touchpoint, {
                  state: {
                    dataRecord: record,
                    action_type: "EDIT",
                  },
                })
              }
            />
          )}

          {roleUser[0]?.isDelete && (
            <Button
              className="btn-delete"
              shape="circle"
              icon={<DeleteFilled style={{ color: "#F04438" }} />}
              onClick={() => onDelete(record.touchPointAnswerId)}
            />
          )}
        </Space>
      ),
    },
  ];

  return (
    <div style={{ marginTop: 20 }}>
      <Row gutter={[24, 12]}>
        <Col span={24}>
          รายการทั้งหมด{" "}
          <span style={{ color: token.thPrimary, fontWeight: 700 }}>
            {pageValues?.total}
          </span>{" "}
          รายการ
        </Col>
        <Col span={24}>
          <Table
            locale={{ emptyText: <NotFound /> }}
            loading={loading}
            rowKey={"key"}
            dataSource={dataSource}
            columns={columns}
            pagination={false}
            scroll={{
              x: 2000,
            }}
            onChange={onSorter}
          />
        </Col>
        <Col span={24} align="right">
          <Pagination
            showSizeChanger
            defaultCurrent={pageValues.page + 1 || 1}
            total={pageValues.total || 10}
            onChange={onPageChange}
            showTotal={(total) => `รวม ${total} รายการ`}
          />
        </Col>
      </Row>
    </div>
  );
};

export default TableList;
